import React, { useState, useCallback, useEffect } from 'react';

import pipe from '@/pages/dashboard/utils/pipe';

import { ALL_VALUE } from '../constants'
import { SelectorMultipleProps } from '../types';

const useIndex = (props: SelectorMultipleProps, bindClassName) => {
  let {
    value: valueProps,
    options,
    onOpen,
    onClose,
    onChange
  } = props;
  const defaultSelectList = [];
  const [isOpen, setIsOpen] = useState(false);
  
  const [value, setValue] = useState(valueProps?.[0] !== ALL_VALUE ? valueProps : defaultSelectList);
  const [checkedAll, setCheckedAll] = useState(valueProps?.[0] === ALL_VALUE);

  // 选择 change 事件
  const handleChange = (value: string[]) => {
    let selectList: string[] = [...(value ?? [])];
    // 后端筛选器默认值传空的时候，
    // if(otherMsg!=='isInit') {
    //   setCheckedAll(selectList?.length === 0);
    // } else {
    //   const isAll = value?.length === 1 && value?.[0] === '255'
    //   setCheckedAll(isAll)
    // }
    const isAll = value?.length === 1 && value?.[0] === ALL_VALUE;
    const selectValue = !isAll ? selectList?.filter(item => item !== ALL_VALUE) : selectList
    setCheckedAll(isAll)
    setValue(selectValue);
    onChange?.(selectList?.length <= 0 ? [ALL_VALUE] : selectValue);
  }

  const handleRadioChange = (value) => {
    handleChange([value])
  }

  const handleAll = useCallback((renderOptions = options, isClear) => {
    let newValue: any[] = []
    const isAllOptions = renderOptions?.length === options?.length

    if (isAllOptions) {
      // 清空全选，则赋值‘255
      newValue = isClear ? [ALL_VALUE] : options?.map(item => item?.value)
    }else {
      if (isClear) {
        const renderOptionsValues = renderOptions?.map(item => item?.value)
        newValue = value?.filter(valueItem => !renderOptionsValues?.includes(valueItem)) ?? []
      }else {
        const resultMap = (() => {
          const map = {}

          value?.forEach(item => (map[item] = true))
          renderOptions?.forEach(item => (map[item?.value] = true))

          return map
        })()
        newValue = Object.keys(resultMap)
      }
    }

    handleChange(newValue);
  }, [value, options])

  // 删除
  const handleDelete = useCallback((id) => {
    const newValue = value ? value.filter(item => item !== id) : [];
    handleChange(newValue);
  }, [value])

  // 打开下拉框
  const handleOpen = () => {
    setIsOpen(true);
    onOpen?.()
  }

  // 关闭下拉框
  const handleClose = () => {
    setIsOpen(false);
    onClose?.()
  }

  const resetFunc = (value: string[]) => {
    let selectList: string[] = [...(value ?? [])];
    const isAll = value?.length === 1 && value?.[0] === ALL_VALUE;
    const selectValue = !isAll ? selectList?.filter(item => item !== ALL_VALUE) : selectList
    setCheckedAll(isAll)
    setValue(selectValue);
  }

  // 外部受控
  useEffect(() => {
    if(!valueProps) return;
    // 后端可能配置默认值为空，所以这里不能筛选掉全选，筛选掉后，会影响后面的全选操作（如先选择选项，重置的时候，全选不了）
    // const newValue = valueProps?.filter(item => item !== ALL_VALUE) ?? [];
    resetFunc(valueProps);
  }, [JSON.stringify(valueProps)])

  return {
    value,
    options,
    isOpen,
    checkedAll,
    handleAll,
    handleOpen,
    handleClose,
    handleDelete,
    handleChange,
    handleRadioChange
  }
}

export default useIndex
